import { render, staticRenderFns } from "./EliteIntroduce.vue?vue&type=template&id=4165e0b8&scoped=true&"
import script from "./EliteIntroduce.vue?vue&type=script&lang=js&"
export * from "./EliteIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./EliteIntroduce.vue?vue&type=style&index=0&id=4165e0b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4165e0b8",
  null
  
)

component.options.__file = "EliteIntroduce.vue"
export default component.exports